import styled from 'styled-components';

export const CheckboxContainer = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-template-rows: auto;
  grid-template-areas: 'checkbox label';
  align-items: center;
  cursor: pointer;
  &:hover {
    background: ${(props) =>
      props.theme.serviceDeskInputDropDownHoverBackground};
  }
`;
export const Label = styled.label`
  grid-area: label;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
  color: ${(props) => props.theme.serviceDeskTextColorPrimary};
`;
